import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, PropType } from "vue";
import { Validator, ValidatorBase, ValidatorStatus } from "@/models/store/validator";
import { useValidatorsStore } from "@/store/validators.store";
import ValidatorLogo from "../commons/ValidatorLogo.vue";
import BlockHidingDropdown from "../commons/BlockHidingDropdown.vue";
import ValidatorsStatusLabel, { ValidatorsStatusLabelType } from "@/components/commons/ValidatorsStatusLabel.vue";
import { RedelegationDirection, getRedelagatePlaceholder } from "@/components/staking/StakingRedelegate.ts";

interface ActivityFilterData {
  types: ValidatorStatus[],
  status: ValidatorsStatusLabelType,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StakingRedelegate',
  props: {

  disabled: {
    type: Boolean,
    default: false
  },
  validator: {
    type: Validator,
    required: true
  },
  modelValue: Validator,
  class: String,
  field: Object,
  redelegationDirection: {
    type: String as PropType<RedelegationDirection>,
    required: true
  }
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const props = __props;

function onValueChange(e: any) {
  emit('update:modelValue', e);
}

const enableValidatorsHide = ref(true);

function atHideChild(e: any) {
  enableValidatorsHide.value = true;
}
function atShowChild(e: any) {
  enableValidatorsHide.value = false;
}

const activityFilterOptions: ActivityFilterData[] = [
  {types: [ValidatorStatus.Bonded, ValidatorStatus.Unbonded, ValidatorStatus.Unbonding, ValidatorStatus.Unspecified], status: 'all'},
  {types: [ValidatorStatus.Bonded], status: 'active'},
  {types: [ValidatorStatus.Unbonded, ValidatorStatus.Unbonding, ValidatorStatus.Unspecified], status: 'inactive'},
  ];

const activityFilter = ref<ActivityFilterData>(activityFilterOptions[0]);

const redelagateFilter = ref('');


const filteredValidators = computed<ValidatorBase[]>(() => {
  if (props.redelegationDirection === RedelegationDirection.TO) {
    return filterForRedelegation((val: Validator) => {
      const activityTypeFilter = activityFilter.value.types.some((type) => {
        return type === val.status;});

      // const valToLowerCase = redelagateToFilter.value.toLowerCase();
      // const searchFilter = String(val.rank).toLowerCase().includes(valToLowerCase)
      // || val.description.moniker.toLowerCase().includes(valToLowerCase);

      return searchFilter(val) && activityTypeFilter;
    });
  } else {
    return useValidatorsStore().getUserDelgationsValidators.filter((val) => {
      return searchFilter(val) && val.operatorAddress !== props.validator.operatorAddress;
    });
  }
});

function searchFilter(val: Validator): boolean {
  if (!redelagateFilter.value) {
    return true;
  }
  const valToLowerCase = redelagateFilter.value.toLowerCase();
  return String(val.rank).toLowerCase().includes(valToLowerCase)
      || val.description.moniker.toLowerCase().includes(valToLowerCase);
}


const redelegateValidator = ref<Validator>();

function filterForRedelegation(filter?: (val: Validator) => boolean): ValidatorBase[]{
  const filtred = useValidatorsStore().getValidators.filter(
    element => {
        const condition = element.operatorAddress !== props.validator.operatorAddress;
        if (!filter) {
          return condition;
        } else {
          return condition && filter(element);
        }
      }
    )
    .map((val) => { // mapping to new object because of vee validate uses JSON.stringify that does not support bigint
        return {
        rank: val.rank,
        operatorAddress: val.operatorAddress,
        description: {
          moniker: val.description.moniker,
          pictureUrl: val.description.pictureUrl
        }
      };
      }
    );
  return filtred;
}


const __returned__ = { emit, props, onValueChange, enableValidatorsHide, atHideChild, atShowChild, activityFilterOptions, activityFilter, redelagateFilter, filteredValidators, searchFilter, redelegateValidator, filterForRedelegation, ValidatorLogo, BlockHidingDropdown, ValidatorsStatusLabel, get RedelegationDirection() { return RedelegationDirection }, get getRedelagatePlaceholder() { return getRedelagatePlaceholder } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})